window.addEventListener("DOMContentLoaded", () => {
    const inputQuery = ".tribe-tickets__form-field-input-wrapper input[type=tel]";
    const ticketBuy = document.querySelectorAll(".action-submit-atendee");
    const inputMask = (el) => {
        // remove all non-digit characters
        const value = el.value.replace(/\D/g, "");
        // regex pattern for 10 digits
        const pattern = /(\d{0,3})(\d{0,3})(\d{0,4})/;
        // new value
        let formattedValue = value.replace(pattern, "($1)$2-$3");
        if (formattedValue.length > 13) {
            formattedValue = formattedValue.substring(0, 13);
        }

        el.value = formattedValue;
        if (el.value === "()-") el.value = value;
    };

    function telephoneMask() {
        setTimeout(() => {
            const input = document.querySelectorAll(inputQuery);
            input.forEach((e) => {
                if (e) e.addEventListener("input", () => inputMask(e));
            });
        }, 100);
    }

    if (ticketBuy) {
        ticketBuy.forEach((e) => {
            e.addEventListener("click", function () {
                telephoneMask();
                if (document.querySelector(".tribe-tickets__tickets-item-quantity-add")) {
                    document
                        .querySelector(".tribe-tickets__tickets-item-quantity-add")
                        .addEventListener("click", () => {
                            telephoneMask();
                        });
                }
            });
        });
    }

    addEventListener("change", (event) => {
        telephoneMask();
    });

    const updateTickets = document.querySelector(".page-tribe-attendee-registration");

    if (updateTickets) {
        telephoneMask();
    }
});
